module.exports = __webpack_public_path__ + "static/media/logobg.5e129994.jpg";